import $ from 'jquery';
import Swal from 'sweetalert2';

const validation = form => {
  let isValid = true;

  // Iteração dos inputs do form
  $(form.elements).each(function (_, el) {
    // Se for um elemento válido
    if (['text', 'textarea', 'select-one', 'checkbox', 'file'].includes(el.type) && $(el).is(':visible')) {
      // Se for um campo obrigatório
      if ($(el).attr('required')) {
        // Se for input ou select
        if (['text', 'textarea', 'select-one', 'file'].includes(el.type)) {
          if (!el.value.length) {
            $(el).addClass('error').next('[data-error-text]').text('Campo obrigatório.');
            isValid = false;
          }
        }

        // Se for um checkbox
        if (['checkbox'].includes(el.type)) {
          if (!$(`[name="${el.name}"]`).is(':checked')) {
            $(el).closest('[data-checkbox-container]').find('[data-error-text]').text('Campo obrigatório.');
            isValid = false;
          }
        }
      }

      // Se for obrigatório o value ficar entre um intervalo numero
      if ($(el).hasClass('js-form-numeric-range')) {
        let min = parseInt($(el).attr('data-min'));
        let max = parseInt($(el).attr('data-max'));
        let value = parseInt($(el).val());

        if (value < min || value > max) {
          $(el).addClass('error').next('[data-error-text]').text(`Informe um número entre ${min} e ${max}.`);
          isValid = false;
        }

        if (!Number.isInteger(value)) {
          $(el).addClass('error').next('[data-error-text]').text(`Informe um número entre ${min} e ${max}.`);
          isValid = false;
        }
      }
    }
  });

  return isValid;
};

export const submitSubscribesForm = toExecute => {
  // Submit do formulário
  $(document).on('submit', '.js-form-modal', function (e) {
    e.preventDefault();

    let formData = new FormData(this);

    if (validation(this)) {
      $.ajax({
        type: 'POST',
        url: '/formulario-de-acao/enviar',
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
          if (data.success) {
            $('#modal-form').remove();
            toExecute(data.challenge_id, data.user_id);
          } else {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    }
  });

  // Submit do formulário de usuários não logados
  $(document).on('submit', '.js-form-unlogged', function (e) {
    if (!validation(this)) {
      e.preventDefault();
    }
    removeErrorOnChangeInputs(this);
  });

  handleDependentFields();
};

// Abre o formulário de inscrição
export const callSubscribesForm = (challenge_id, user_id) => {
  $.ajax({
    type: 'POST',
    url: '/formulario-de-acao/',
    data: {
      challenge_id,
      user_id,
      _token: $('meta[name="csrf-token"]').attr('content'),
    },
    dataType: 'json',
    success: function (data) {
      if (data.success) {
        $('body').append(data.html);
        removeErrorOnChangeInputs();
      } else {
        Swal.fire(data.title, data.message, data.type);
      }
    },
  });

  handleDependentFields();
};

// Handle dependent fields visibility on change
const handleDependentFields = () => {
  $(document).on('change', '.js-select-change', function () {
    let questionId = $(this).attr('data-question');
    let parentId = $(this).val();

    let $toHide = $(`[data-parent-question="${questionId}"]`);
    let $toShow = $(`[data-parent-question="${questionId}"][data-parent-answer="${parentId}"]`);

    $toHide.hide();
    $toShow.show();
  });
};

// Função responsável por remover os erros no change de um input, select, etc
const removeErrorOnChangeInputs = $form => {
  let elements;
  if (!$form) {
    elements = $('.js-form-modal')[0].elements;
  } else {
    elements = $($form)[0].elements;
  }

  $(elements).each(function (_, el) {
    // Remove o erro dos elementos input
    if (['text', 'textarea', 'select-one', 'file'].includes(el.type)) {
      $(el).on('change input', function () {
        $(this).removeClass('error').next('[data-error-text]').text('');
      });
    }

    // Remove o erro dos elementos checkbox
    if (['checkbox'].includes(el.type)) {
      $(el).on('change', function () {
        $(el).closest('[data-checkbox-container]').find('[data-error-text]').text('');
      });
    }
  });
};
